<template>
  <div>
    <Navbar/>
    <b-jumbotron class="mt-3 bg-light">
        <template v-slot:header variant="success">Checkout Successfully!</template>

        <template v-slot:lead>
            This is a simple checkout page, a checkout page will give you payment information based on your cart.
        </template>

        <hr class="my-4">

        <h2 class="text-success">
            Total: ${{ getTotal }}
        </h2>

        <b-button variant="success" @click="toHomePage">Continue Shopping...</b-button>
    </b-jumbotron>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'

export default {
  name: 'Checkout',
  components: {
    Navbar
  },
  computed: {
    getTotal () {
      return this.$store.state.totalCash
    }
  },
  methods: {
    toHomePage () {
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>

<style>

</style>
